import React, { Fragment, useEffect, useRef } from 'react';

const Header = ({ title, subtitle, children }) => {
  const ref = useRef();
  let ariaLabel = subtitle;
  if (title) {
    ariaLabel += ` ${title}`;
  }

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [ref]);

  return (
    <Fragment>
      <div className="text-center mb-[24px] mt-[16px]">
        <div
          role="dialog"
          ref={ref}
          tabIndex={-1}
          className="sr-only"
          aria-label={ariaLabel}
        />
        <div className="text-gray-900 text-page-subtitle font-normal uppercase mb-[12px]">
          {subtitle}
        </div>
        <h1
          id="mainHeading"
          tabIndex="-1"
          className="w-full text-center text-gray-900 text-page-title font-medium m-0 inline-block break-words ..."
        >
          {title}
        </h1>
        <div className="flex flex-col justify-center">{children}</div>
      </div>
    </Fragment>
  );
};

export default Header;
